export default __webpack_public_path__ + "static/media/ic_app_download.9c4c471f.png";